import baseApi from "./baseApi";

const getAll = async () => {
    try {
        const response = baseApi.get('/graficos/projetos',{})
        return response
    } catch(error){
        return error;
    }
}


const faturas_pagas_nao = async (id, value = null) => {
 
    try {
        const response = baseApi.get('/graficos/faturas/' + id + '/' + value ,{})
        return response
    } catch(error){
        return error;
    }
}

export default {
    getAll,
    faturas_pagas_nao
}